import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';
import * as actionCreators from '../actions/auth';
import PropTypes from "prop-types";


import LoadingWheel from './Loader'

function mapStateToProps(state) {
    return {
        isAuthenticated: state.auth.isAuthenticated,
        
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}


export function requireAuthentication(Component) {
    class AuthenticatedComponent extends React.Component {
        componentWillMount() {
            this.checkAuth();
            this.setState({
                loaded_if_needed: true,
            });
        }

        componentWillReceiveProps(nextProps) {
            this.checkAuth(nextProps);
        }
    
        checkAuth() {
            if (!this.props.isAuthenticated) {
                    this.props.logoutAndRedirect();
            }
        }

        render() {
            return (
                <div>
                    <div>
                        {this.state.loaded_if_needed
                            ? <Component {...this.props} />
                            : null
                        }
                    </div>
                    
                </div>
            );

        }
    }

    AuthenticatedComponent.propTypes = {
        loginUserSuccess: PropTypes.func,
        isAuthenticated: PropTypes.bool,
    };

    return connect(mapStateToProps, mapDispatchToProps)(AuthenticatedComponent);
}



// WEBPACK FOOTER //
// ./src/components/AuthenticatedComponent.js